module.exports = __webpack_public_path__ + "img/card1.43d5581f.svg";